<template>
  <a-select
    show-search
    :value="field.value"
    :disabled="disabled"
    :placeholder="config.placeholder || `请选择${config.label}`"
    :mode="config.mode"
    :filter-option="filterOption"
    @change="handleChange"
  >
    <a-select-option
      v-for="option in options"
      :key="option.value"
      :value="option.value"
      :label="option.label"
      :disabled="option.disabled"
    >{{ option.label }}</a-select-option>
  </a-select>
</template>
<script>
import { defineComponent, toRef, ref } from 'vue'
import { props } from './helper'
import useRemote from './useRemote'

/**
 * {
    options:[],
    remoteApi: {
      api: apis.auth.platform.getList,
      params: { PageSize: 999, IsActive: 1 },
      attrs: { valueField: 'Id', labelField: 'PlatName' },
    },
 * }
 * 如果存在options则会将options与remote请求回来后的options merge到一起，这样options可以用来放{value:'', label:'全部'}
 */
export default defineComponent({
  props,
  setup(props) {
    const config = toRef(props, 'config')
    const options = ref(config.value.options)

    useRemote(props, res => {
      const { attrs } = props.config.remoteApi
      const remoteOptions = (res.data.List || res.data.list || []).map(i => {
        return { value: i[attrs.valueField], label: i[attrs.labelField] }
      })
      options.value = config.value.options
        ? [...config.value.options, ...remoteOptions]
        : remoteOptions
    })

    const filterOption = (input, option) => {
      return option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
    }

    return {
      options,
      filterOption
    }
  }
})
</script>
<style lang="less" scoped></style>
